import { FC } from 'react';

import AddPartnerNoteModalHeader from './components/AddPartnerModalHeader';
import AddPartnerNoteModalBody from './components/AddPartnerModalBody';
import AddPartnerNoteModalFooter from './components/AddPartnerModalFooter';

import { useAddPartnerNoteModal } from './context/AddPartnerNoteModalContext';
import CustomLoading from '../../CustomLoading';

import '../Modals.scss';

const AddPartnerNoteModal: FC = () => {
  const { data } = useAddPartnerNoteModal();

  return (
    <>
      <AddPartnerNoteModalHeader />
      <AddPartnerNoteModalBody />
      <AddPartnerNoteModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddPartnerNoteModal;
